import { captureMessage } from '@sentry/react';
import config from 'config/config';
import { BusinessChoiceType } from 'features/utils/types';
import { useSelector } from 'react-redux';
import { BusinessChoiceSelector } from 'store/selectors';

export function getPanelListFromBusinessChoice(
  businessChoice: BusinessChoiceType | undefined
) {
  if (!businessChoice) {
    console.warn('usePanelList | No business choice selected. Taking b2c');
    captureMessage('usePanelList | No business choice selected. Taking b2c');
    return config.options.panels.b2c;
  }
  return config.options.panels[businessChoice];
}

export default function usePanelList() {
  const businessChoice = useSelector(BusinessChoiceSelector);

  return getPanelListFromBusinessChoice(businessChoice);
}
